import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Programa from "../views/Programa.vue";
import Error from "../views/Error/404.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/programa/:code/:year?",
        name: "Programa",        
        component: Programa,
    },
    {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/About.vue"),
    },
    {
        path: "/:catchAll(.*)",
        name: "Error",
        component: Error,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
